import React from "react";
import PropTypes from "prop-types";
import * as styles from "./ItemDescription.module.scss";

const ReusableItemDesc = ({
  icon,
  title,
  description,
  textColor,
  marginBottom,
}) => {
  const boxStyle = {
    color: textColor,
  };
  const iconStyle = {
    marginBottom: `${marginBottom}px`,
    color: "white",
  };

  return (
    <div className={styles.Box} style={boxStyle}>
      <img src={icon} style={iconStyle} />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

ReusableItemDesc.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  marginBottom: PropTypes.number,
};

ReusableItemDesc.defaultProps = {
  textColor: "white",
  marginBottom: 20,
};

export default ReusableItemDesc;
